import type { ReactNode } from "react";

export type SettingsIconName =
  | "store"
  | "link"
  | "calendar"
  | "services"
  | "team"
  | "user"
  | "shield"
  | "eye"
  | "star"
  | "receipt"
  | "card"
  | "plug"
  | "search"
  | "chevron"
  | "bell";

export function SettingsIcon({ name }: { name: SettingsIconName }) {
  const paths: Record<SettingsIconName, ReactNode> = {
    store: <><path d="M5 10h14" /><path d="M6 10l1-5h10l1 5" /><path d="M7 10v9h10v-9" /><path d="M10 19v-5h4v5" /></>,
    link: <><path d="M10 13a5 5 0 0 0 7.1 0l1.6-1.6a5 5 0 0 0-7.1-7.1L10.5 5.4" /><path d="M14 11a5 5 0 0 0-7.1 0l-1.6 1.6a5 5 0 0 0 7.1 7.1l1.1-1.1" /></>,
    calendar: <><rect x="5" y="6" width="14" height="14" rx="3" /><path d="M8 4v4" /><path d="M16 4v4" /><path d="M5 10h14" /></>,
    services: <><path d="M4 19 19 4" /><path d="M7 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z" /><path d="M7 21a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z" /></>,
    team: <><path d="M8.5 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" /><path d="M15.5 10a2.5 2.5 0 1 0 0-5" /><path d="M3.5 19a5 5 0 0 1 10 0" /><path d="M14 15.5a4.5 4.5 0 0 1 6 3.5" /></>,
    user: <><path d="M12 12a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" /><path d="M6 20a6 6 0 0 1 12 0" /></>,
    shield: <><path d="M12 3 5 6v5c0 4.5 3 8 7 10 4-2 7-5.5 7-10V6l-7-3Z" /><path d="M9.5 12.2 11.4 14l3.4-4" /></>,
    eye: <><path d="M3 12s3.2-6 9-6 9 6 9 6-3.2 6-9 6-9-6-9-6Z" /><circle cx="12" cy="12" r="2.5" /></>,
    star: <path d="m12 3 2.7 5.5 6.1.9-4.4 4.3 1 6-5.4-2.8-5.4 2.8 1-6-4.4-4.3 6.1-.9L12 3Z" />,
    receipt: <><path d="M7 4h10v16l-2-1.2-2 1.2-2-1.2-2 1.2-2-1.2V4Z" /><path d="M9 8h6" /><path d="M9 12h6" /><path d="M9 16h4" /></>,
    card: <><rect x="4" y="6" width="16" height="12" rx="3" /><path d="M4 10h16" /><path d="M8 15h3" /></>,
    plug: <><path d="M9 7V3" /><path d="M15 7V3" /><path d="M7 7h10v4a5 5 0 0 1-10 0V7Z" /><path d="M12 16v5" /></>,
    search: <><circle cx="11" cy="11" r="6" /><path d="m16 16 4 4" /></>,
    chevron: <path d="m9 6 6 6-6 6" />,
    bell: <><path d="M18 9a6 6 0 1 0-12 0c0 7-2 7-2 7h16s-2 0-2-7" /><path d="M10 20a2 2 0 0 0 4 0" /></>
  };

  return (
    <svg viewBox="0 0 24 24" focusable="false">
      {paths[name]}
    </svg>
  );
}
